import { Box } from '@mui/material';
import { useEffect } from 'react';
import { SetValueConfig, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
 reportsGenerateStart,
 ReportType,
} from '../../../redux/reports/reportsSlice';
import { RootState } from '../../../redux/store';
import SelectApiManual from '../SelectApiManual';

const ToolbarReports = () => {
 const dispatch = useDispatch();
 const report = useSelector((state: RootState) => state.reports.report);
 const success = useSelector((state: RootState) => state.reports.success);
 const { t } = useTranslation();

 const { control, setValue, reset } = useForm({
  mode: 'onChange',
 });

 const generateReport = ({
  value,
  type,
 }: {
  value: number;
  type: 'Word' | 'PdfReport';
 }) => {
  dispatch(
   reportsGenerateStart({
    type,
    CarId: 4,
    ReportTemplateId: value,
   }),
  );
 };

 useEffect(() => {
  //   console.log('success', success);
  if (success?.reportsGenerate) {
   if (report.file && report.type && report.extension && report.name) {
    // this fires from useReportDialog
    // downloadBase64File(report.file, report.name, report.type, report.extension);
    reset();
   }
  }
 }, [success]);

 const handleValueChange = (
  name: string,
  value: ReportType | null,
  options: SetValueConfig,
 ) => {
  console.log('handleValueCHange', value);
  setValue(name, value, options);
  if (value) {
   generateReport({
    value: value.Id,
    type: value.Type === 'Word' ? 'Word' : 'PdfReport', // fix it
   });
  }
 };

 return (
  <Box sx={{ width: 200, display: { xs: 'none', md: 'block' } }}>
   <SelectApiManual
    name="ReportTemplateId"
    url="/api/Reports/v1"
    filterVar="Name"
    fixedFilters={[
     {
      field: 'DocumentType',
      operator: 'eq',
      value: 'Multi',
     },
    ]}
    isEditable
    label={t('gridToolbar.report')}
    control={control}
    setValue={handleValueChange}
    disabled={false}
   />
  </Box>
 );
};
export default ToolbarReports;
